import { useParams, Link } from "react-router-dom";
import { ArrowRight, Clock3 } from "lucide-react";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { WhatsAppButton, BookButton } from "../components/CTAButtons";
import { GUIDE_ARTICLES, getGuide } from "../data/guides";
import { breadcrumbSchema, multiGraph } from "../components/Schema";
import NotFound from "./NotFound";

export default function GuideDetail({ onBook }) {
  const { slug } = useParams();
  const g = getGuide(slug);
  if (!g) return <NotFound />;

  const crumbs = [
    { label: "Home", href: "/" },
    { label: "Guides", href: "/guides/" },
    { label: g.title },
  ];
  const related = (g.relatedSlugs || [])
    .map((s) => ({ slug: s, meta: GUIDE_ARTICLES[s] }))
    .filter((x) => x.meta);

  return (
    <>
      <Seo
        title={g.seoTitle}
        description={g.description}
        path={`/guides/${slug}/`}
        type="article"
        jsonLd={multiGraph(breadcrumbSchema(crumbs))}
      />
      <section className="content-hero section-pad narrow">
        <Breadcrumbs items={crumbs} />
        <p className="eyebrow"><Clock3 size={13} /> {g.read} read · {g.kicker}</p>
        <h1>{g.title}</h1>
        <p className="large-copy">{g.intro}</p>
      </section>

      <section className="section-pad narrow guide-body">
        {g.sections.map((sec, i) => (
          <article key={i} className="guide-section" data-testid={`guide-section-${i}`}>
            <h2>{sec.h}</h2>
            {sec.body.map((p, j) =>
              p.length < 110 && (p.includes(":") || p.includes("₹")) ? (
                <p key={j} className="large-copy bullet">• {p}</p>
              ) : (
                <p key={j} className="large-copy">{p}</p>
              ),
            )}
          </article>
        ))}
        <div className="guide-cta-card">
          <p className="eyebrow">Ready to book?</p>
          <h3>Zorba International Spa, Chandrasekharpur.</h3>
          <p className="muted">
            Our featured wellness partner publishes exact prices for every service. Send a quick enquiry
            and the spa will confirm from there.
          </p>
          <div className="actions-row">
            <BookButton onBook={onBook} label="Start enquiry" testid="guide-cta-book" />
            <WhatsAppButton label="WhatsApp Zorba" source={`guide_${slug}`} testid="guide-cta-whatsapp" />
          </div>
        </div>
      </section>

      {related.length > 0 && (
        <section className="section-pad narrow">
          <h2>More guides</h2>
          <div className="guide-grid">
            {related.map((r, i) => (
              <Link to={`/guides/${r.slug}/`} key={r.slug} className="guide-card linked" data-testid={`related-guide-${i}`}>
                <span className="card-kicker">{r.meta.read} read</span>
                <h3>{r.meta.title}</h3>
                <span className="text-link"><ArrowRight size={14} /></span>
              </Link>
            ))}
          </div>
        </section>
      )}
    </>
  );
}
